import { useEffect } from 'react'

import useCreateChatBotSettings from '~/features/agents/hooks/useCreateChatBotSettings'
import useGetChatbotSettings from '~/features/agents/hooks/useGetChatbotSettings'
import useIsPartner from '~/features/partners/hooks/useIsPartner'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { defaultChatBotLayout } from '~/features/settings/components/chatBot/utils'
import { sessionStore } from '~/store'

const useGetOrPostChatbotSettings = () => {
  const agentId = sessionStore((state) => state.agent.id) || ''
  const { partner } = usePartnerCentralized()
  const isPartner = useIsPartner()

  const { data: chatSettings, isSuccess } = useGetChatbotSettings(agentId)
  const { data: defaultChatbot, mutate: createChatbotSettingsMutation } =
    useCreateChatBotSettings()

  const defaultLayout =
    isPartner && partner.chatTemplateColors
      ? partner.chatTemplateColors
      : defaultChatBotLayout

  useEffect(() => {
    if (isSuccess && !chatSettings?.data) {
      createChatbotSettingsMutation({
        agentId,
        layout: defaultLayout,
      })
    }
  }, [
    isSuccess,
    chatSettings,
    createChatbotSettingsMutation,
    agentId,
    defaultLayout,
  ])

  if (chatSettings?.data && chatSettings?.data.layout) {
    return chatSettings?.data.layout
  }

  return defaultChatbot?.data?.layout
}

export default useGetOrPostChatbotSettings
